/* SOLEN — theme.js
   Cart drawer, free-shipping bar, AJAX cart updates, discount code passthrough. */
(function () {
  'use strict';

  var FREE_THRESHOLD_CENTS = parseInt(document.body.getAttribute('data-free-shipping-cents') || '5000', 10);
  var pendingDiscount = null;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function T(key, fallback) {
    return (window.SolenI18n && window.SolenI18n[key]) || fallback;
  }

  function formatMoney(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + euros;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (href === '#' || href.length < 2) return;
    if (link.hasAttribute('data-cart-close') || link.hasAttribute('data-cart-open')) return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  function openDrawer() {
    var d = $('#CartDrawer');
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeDrawer() {
    var d = $('#CartDrawer');
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var openEl = e.target.closest('[data-cart-open]');
    if (openEl) { e.preventDefault(); openDrawer(); return; }
    var closeEl = e.target.closest('[data-cart-close]');
    if (closeEl) { e.preventDefault(); closeDrawer(); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function buildItemHTML(item) {
    var imgHTML;
    if (item.featured_image && item.featured_image.url) {
      var src = item.featured_image.url;
      imgHTML = '<img src="' + src + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy">';
    } else {
      imgHTML = '<div class="item-jar"><div class="item-jar-label">SOLEN<small>' +
        item.product_title.toUpperCase().substring(0, 12) + '</small></div></div>';
    }
    var meta = (item.variant_title && item.variant_title !== 'Default Title')
      ? item.variant_title.toLowerCase() : '';
    return '<div class="item" data-cart-item data-key="' + item.key + '">' +
      '<a href="' + item.url + '" class="item-img">' + imgHTML + '</a>' +
      '<div class="item-info">' +
      '<a href="' + item.url + '" class="item-name">' + item.product_title.toUpperCase() + '</a>' +
      '<div class="item-meta">' + meta + '</div>' +
      '<div class="item-controls">' +
      '<div class="qty">' +
      '<button type="button" data-cart-qty data-key="' + item.key + '" data-delta="-1" aria-label="Decrease">−</button>' +
      '<span data-qty-display>' + item.quantity + '</span>' +
      '<button type="button" data-cart-qty data-key="' + item.key + '" data-delta="1" aria-label="Increase">+</button>' +
      '</div>' +
      '<div class="item-price">' + formatMoney(item.final_line_price) + '</div>' +
      '</div>' +
      '<button type="button" class="item-remove" data-cart-remove data-key="' + item.key + '">' + T('remove', 'remove') + '</button>' +
      '</div>' +
      '</div>';
  }

  function buildCartFooterHTML(cart) {
    return '<div class="discount">' +
      '<form class="discount-form" data-discount-form>' +
      '<input type="text" name="discount" placeholder="' + T('discountPh', 'discount code') + '" autocomplete="off" data-discount-input>' +
      '<button type="submit">' + T('apply', 'apply →') + '</button>' +
      '</form>' +
      '<div class="applied-code" data-applied-code style="display:none;">' +
      '<span><span data-code-name></span> ' + T('applied', 'will be applied at checkout') + '</span>' +
      '<button type="button" data-clear-code style="background:none;border:none;font-family:inherit;color:var(--muted);cursor:pointer;">' + T('remove', 'remove') + '</button>' +
      '</div>' +
      '</div>' +
      '<div class="totals">' +
      '<div class="total-row"><span class="label">' + T('subtotal', 'subtotal') + '</span><span data-cart-subtotal>' + formatMoney(cart.total_price) + '</span></div>' +
      '<div class="total-row"><span class="label">' + T('shipping', 'shipping') + '</span><span><em style="font-family:var(--serif);font-style:italic;color:var(--stone);font-size:12px;">' + T('calculated', 'calculated at checkout') + '</em></span></div>' +
      '<div class="total-row subtotal"><span class="label">' + T('total', 'total') + '</span><span data-cart-total>' + formatMoney(cart.total_price) + '</span></div>' +
      '</div>' +
      '<div class="checkout-area">' +
      '<form action="/cart" method="post" data-checkout-form>' +
      '<button type="submit" name="checkout" class="checkout-btn">' + T('checkout', 'checkout') + ' →</button>' +
      '</form>' +
      '<div class="fine-print">' + T('fine1', 'no plastic · personalised seal · packed by hand') + '<em>' + T('fine2', '"light it slowly."') + '</em></div>' +
      '</div>';
  }

  function renderDrawer(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    $$('.cart-link').forEach(function (el) { el.textContent = T('bag', 'bag') + ' (' + cart.item_count + ')'; });

    var shipEl = $('[data-cart-shipping]');
    if (shipEl) {
      var threshold = parseInt(shipEl.getAttribute('data-threshold'), 10) || FREE_THRESHOLD_CENTS;
      var remaining = threshold - cart.total_price;
      var fill = $('[data-shipping-fill]');
      var msg = $('[data-shipping-msg]');
      if (remaining <= 0) {
        shipEl.classList.add('complete');
        if (fill) fill.style.inset = '0';
      } else {
        shipEl.classList.remove('complete');
        var pct = Math.min(100, (cart.total_price / threshold) * 100);
        if (fill) fill.style.inset = '0 ' + (100 - pct) + '% 0 0';
        if (msg) {
          msg.innerHTML = '<em>' + T('add', 'Add') + '</em> <strong>' + formatMoney(remaining) +
            '</strong> <em>' + T('more', 'more for complimentary shipping in Italy.') + '</em>';
        }
      }
    }

    var itemsEl = $('[data-cart-items]');
    var panel = $('.cart-drawer-panel');

    if (cart.item_count === 0) {
      if (itemsEl) {
        itemsEl.innerHTML = '<div class="cart-empty-state"><p>' + T('empty', 'Your bag is empty.') + '</p>' +
          '<a href="/collections/all" class="story-link">' + T('browse', 'browse the collection') + ' →</a></div>';
      }
      var toRemove = ['.discount', '.totals', '.checkout-area'];
      toRemove.forEach(function (sel) {
        var el = panel ? $(sel, panel) : $(sel);
        if (el) el.remove();
      });
    } else {
      var needsRebuild = false;
      if (!itemsEl || itemsEl.querySelector('.cart-empty-state')) {
        needsRebuild = true;
      } else {
        cart.items.forEach(function (item) {
          if (!itemsEl.querySelector('[data-cart-item][data-key="' + item.key + '"]')) {
            needsRebuild = true;
          }
        });
      }

      if (needsRebuild && itemsEl) {
        itemsEl.innerHTML = cart.items.map(buildItemHTML).join('');
      } else if (itemsEl) {
        cart.items.forEach(function (item) {
          var itemEl = itemsEl.querySelector('[data-cart-item][data-key="' + item.key + '"]');
          if (itemEl) {
            var qty = itemEl.querySelector('[data-qty-display]');
            if (qty) qty.textContent = item.quantity;
            var price = itemEl.querySelector('.item-price');
            if (price) price.textContent = formatMoney(item.final_line_price);
          }
        });
        $$('[data-cart-item]', itemsEl).forEach(function (el) {
          var key = el.getAttribute('data-key');
          var found = cart.items.find(function (i) { return i.key === key; });
          if (!found) {
            el.style.transition = 'opacity 0.3s';
            el.style.opacity = '0';
            setTimeout(function () { el.remove(); }, 300);
          }
        });
      }

      if (panel && !$('.checkout-area', panel)) {
        var footer = document.createElement('div');
        footer.innerHTML = buildCartFooterHTML(cart);
        while (footer.firstChild) panel.appendChild(footer.firstChild);
      } else {
        var subtotalEl = $('[data-cart-subtotal]');
        var totalEl = $('[data-cart-total]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      }
    }
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderDrawer)
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (!qtyBtn) return;
    e.preventDefault();
    var key = qtyBtn.getAttribute('data-key');
    var delta = parseInt(qtyBtn.getAttribute('data-delta'), 10);
    var itemEl = qtyBtn.closest('[data-cart-item]');
    var qtyEl = itemEl.querySelector('[data-qty-display]');
    var newQty = Math.max(0, parseInt(qtyEl.textContent, 10) + delta);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(renderDrawer)
      .catch(function () {});
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    var key = rm.getAttribute('data-key');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(renderDrawer)
      .catch(function () {});
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-ajax="true"]')) return;
    e.preventDefault();
    var fd = new FormData(form);
    var btn = form.querySelector('button[type="submit"]');
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.textContent = T('adding', 'adding...'); btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = T('added', 'added ✓'); }
        refreshCart().then(openDrawer);
        setTimeout(function () { if (btn) { btn.textContent = orig; btn.disabled = false; } }, 1600);
      })
      .catch(function () {
        if (btn) { btn.textContent = orig; btn.disabled = false; }
        form.submit();
      });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('[data-discount-input]');
    var code = (input.value || '').trim().toUpperCase();
    if (!code) return;
    pendingDiscount = code;
    var applied = $('[data-applied-code]');
    var name = $('[data-code-name]');
    if (name) name.textContent = code;
    if (applied) applied.style.display = 'flex';
    input.value = '';
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-clear-code]')) return;
    pendingDiscount = null;
    var applied = $('[data-applied-code]');
    if (applied) applied.style.display = 'none';
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-checkout-form]');
    if (!form) return;
    if (pendingDiscount) {
      e.preventDefault();
      window.location.href = '/discount/' + encodeURIComponent(pendingDiscount) + '?redirect=/checkout';
    }
  });

  window.SolenCart = { refresh: refreshCart };
})();